<template>
  
  <input
    ref="inputRef"
    type="text"
    style="border: 1px solid #DDD; border-radius: 5px;"
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: Number, // Vue 2: value
    options: Object
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options)

    return { inputRef }
  },
  mounted() {
    this.$nextTick(() =>this.$refs.inputRef.focus())
  },
}
</script>